import {Component, OnInit, inject} from '@angular/core';
import {DataService} from "../../services/data.service";
import moment from "moment";
import {strategicClassifications} from "../interfaces";
import {FormsModule} from '@angular/forms';
import {NgFor, NgIf, DecimalPipe, DatePipe} from '@angular/common';
import {RouterLink} from '@angular/router';

interface overviewFilter {
    id_department: string;
    id_region: string;
    id_country: string;
    type: string;
    strategic_classification_root: any;
    strategic_classification: any;
}

@Component({
    selector: 'app-overview',
    templateUrl: './overview.component.html',
    styleUrl: './overview.component.scss',
    imports: [FormsModule, NgFor, NgIf, RouterLink, DecimalPipe, DatePipe]
})
export class OverviewComponent implements OnInit {

    private dataService = inject(DataService);

    readonly strategicClassifications = strategicClassifications;

    projects: any[] = [];
    years = [];
    todayLineStart = 0;

    regions: any[] = [];
    departments: any[] = [];
    countries: any[] = [];

    start: any;
    end: any;

    filter: overviewFilter = {
        id_department: 'all',
        id_region: 'all',
        id_country: 'all',
        type: 'all',
        strategic_classification_root: 'all',
        strategic_classification: 'all',
    };

    ngOnInit(): void {
        this.dataService.request("Country/listForDashboard").subscribe(response => {
            this.countries = response.countries;
        })

        this.dataService.request("Department/listForProject").subscribe(response => {
            this.departments = response.departments;
        })

        this.dataService.request("Region/listForProject").subscribe(response => {
            this.regions = response.regions;
        })

        const today = moment();

        this.start = today.clone().startOf('quarter');
        this.end = this.start.clone().add(1, 'year');

        this.todayLineStart = moment().diff(this.start, 'day') / 3.65;
        if (this.todayLineStart < 0) this.todayLineStart = 0;

        // calculate years with quarters
        let currentQuarter = today.quarter(); // 1 - 4
        let currentYear = today.year();

        this.years.push({
            year: currentYear,
            quarters: [currentQuarter],
        });

        for (let i = 1; i < 4; i++) {
            currentQuarter++;
            if (currentQuarter == 5) {
                currentYear++;
                currentQuarter = 1;
                this.years.push({
                    year: currentYear,
                    quarters: [currentQuarter],
                });
            } else {
                this.years[this.years.length - 1].quarters.push(currentQuarter);
            }
        }

        this.listProjects();
    }

    listProjects(): void {
        this.dataService.request("Overview/listProjects", {
            start: this.start.format('YYYY-MM-DD'),
            end: this.end.format('YYYY-MM-DD'),
            filter: this.filter,
        }).subscribe(response => {
            this.projects = response.projects;

            // order projects by end
            this.projects.sort((a, b) => {
                return moment(a.end).isAfter(moment(b.end)) ? 1 : -1;
            });

            // for each project calculate start and end of the bar
            this.projects.forEach(project => {
                if (project.outdated) {
                    project.startPercent = 0;
                    project.endPercent = 100 - moment().diff(this.start, 'day') / 3.65;
                } else {
                    if (moment(project.start).isBefore(this.start)) {
                        project.startPercent = 0;
                    } else {
                        project.startPercent = moment(project.start).diff(this.start, 'day') / 3.65;
                    }

                    if (moment(project.end).isAfter(this.end)) {
                        project.endPercent = 0;
                    } else {
                        project.endPercent = 100 - (moment(project.end).diff(this.start, 'day')) / 3.65;
                    }
                }
            })
        })
    }
}
